import React, { createContext, useReducer, useEffect } from 'react'
import Reducer from './Reducer'

import { getPropertyById } from '../service/property'

import { loadBookingByLegacyId, loadBookingById, loadBookingByPropertyId } from './helpers'
import { RENT_RETENTION_TYPE } from '../constants'

const initialState = {
  user: null,
  property: {},
  booking: {},
  error: null,
  current_step: 1,
  start_date: null,
  end_date: null,
  over_12_months: RENT_RETENTION_TYPE.OVER,
  terms_and_conditions: false,
  is_receipt_file_uploaded: false,
}

const loadBooking = (state, dispatch) => async ({ id, propertyId, legacyBookingId }) => {
  let bookingPromise = null

  if (id) {
    bookingPromise = loadBookingById(state, dispatch)(id)
  }
  if (legacyBookingId) {
    bookingPromise = loadBookingByLegacyId(state, dispatch)(legacyBookingId)
  }
  if (propertyId) {
    bookingPromise = loadBookingByPropertyId(state, dispatch)(propertyId)
  }
  return bookingPromise.then(({ booking, error }) => {
    if (error) {
      return { error }
    }
    if (booking.status !== 'DRAFT' && booking.status !== 'PENDING') {
      window.location.href = `/bookings?property_id=${booking.property_id}`
      return {}
    }
    return { booking }
  })
}

const Store = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  useEffect(() => {
    if (!state.booking.property_id) {
      return
    }
    getPropertyById(state.booking.property_id).then((property) => {
      dispatch({ type: 'SET_PROPERTY', payload: property })
    })
  }, [state.booking.id])

  return <Context.Provider value={[state, dispatch, loadBooking(state, dispatch)]}>{children}</Context.Provider>
}

export const Context = createContext(initialState)
export default Store
